import React from 'react';
import {LocationalConfidence} from '../LocationalState';

interface ConfidenceIconProps {
    type: LocationalConfidence;
    synchronized?: boolean;
    size?: 'm' | 's';
    tooltip?: string;
}

export class ConfidenceIcon extends React.Component<ConfidenceIconProps, any> {

    getContent() {
        if (this.props.synchronized) {
            return '';
        }
        switch (this.props.type) {
            case LocationalConfidence.missing: return '✕';
            case LocationalConfidence.uncertain: return '!';
            case LocationalConfidence.confident: return '✓';
        }
    }

    getClasses() {
        let typeClass;
        switch (this.props.type) {
            case LocationalConfidence.missing:
                typeClass = 'missing';
                break;
            case LocationalConfidence.uncertain:
                typeClass = 'uncertain';
                break;
            case LocationalConfidence.confident:
                typeClass = 'confident';
                break;
            default:
                typeClass = '';
        }
        if (this.props.synchronized) {
            typeClass = 'synchronized';
        }
        const sizeClass = `${this.props.size === 's' ? 'confidence-icon-small' : ''}`;
        return `confidence-icon ${typeClass} ${sizeClass}`;
    }

    render() {
        const text = this.getContent();
        const classes = this.getClasses();
        return <span title={this.props.tooltip} className={classes}>{text}</span>;
    }
}